import React from "react";
import useLicensesStore from "../../../../zustand/licenses.store";
import TmsSelect from "../../tms-select";

const LicenseInstitutionSelect = ({ span }) => {
  const {
    setSelectedInstitution,
    selectedInstitution,
    institutionData,
    clearStates,
  } = useLicensesStore((state) => {
    return {
      setSelectedInstitution: state.setSelectedInstitution,
      selectedInstitution: state.selectedInstitution,
      institutionData: state.institutionData,
      clearStates: state.clearStates,
    };
  });

  return (
    <TmsSelect
      type="col"
      span={span}
      label="Select a Institution"
      setValue={(e) => {
        setSelectedInstitution(e);
        clearStates(
          [
            "createdLicenseData",
            "createdLicenseLeaseData",
            "selectedLicenseLease",
            "selectedLicense",
            "createdArrearsData",
          ],
          []
        );
      }}
      selectClass="w-100"
      value={selectedInstitution}
      data={institutionData?.items?.map((item) => {
        return { name: item.name, id: item.id };
      })}
      optional={true}
    />
  );
};

export default LicenseInstitutionSelect;
